import { USER_CONSTANTS } from '.';

export const DRIVER_ROLES = [USER_CONSTANTS.ROLE.DRIVER, USER_CONSTANTS.ROLE.SEASONAL_DRIVER] as const;
